module.exports = __webpack_public_path__ + "b4d7c103c98e7705308d11726f9b9278.svg";